import script from "./GrnListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GrnListTable.vue?vue&type=script&setup=true&lang=js"

import "./GrnListTable.vue?vue&type=style&index=0&id=ece4aeb6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece4aeb6"]])

export default __exports__